export default __webpack_public_path__ + "static/media/videocam-on.81664b3d.svg";